import * as Cookies from "js-cookie";

export const getAuthToken = (): string | null => {
  try {
    const token = Cookies.getJSON("token");
    return token;
  } catch (e) {
    console.error(e);
  }
  return null;
};

export const setAuthInfo = (id: string, token: string) => {
  try {
    Cookies.set("token", token, { expires: 7 });
    Cookies.set("admin_id", id, { expires: 7 });
  } catch (e) {
    console.error(e);
  }
  return;
};

export const removeAuthInfo = () => {
  try {
    Cookies.remove("token");
    Cookies.remove("admin_id");
  } catch (e) {
    console.error(e);
  }
  return;
};

export const checkAuthToken = (): boolean => {
  if (getAuthToken()) {
    return true;
  }
  return false;
};
